@if (routerLink(); as link) {
	<a [routerLink]="link" class="text-decoration-none">
		<ng-container *ngTemplateOutlet="cardContent" />
	</a>
} @else {
	<ng-container *ngTemplateOutlet="cardContent" />
}

<ng-template #cardContent>
	<div class="card h-100 stat-card" [class.stat-card-clickable]="!!routerLink()">
		<div class="card-body d-flex align-items-center gap-2 gap-md-3 p-3 p-md-4">
			<div class="rounded-circle d-flex align-items-center justify-content-center stat-icon-wrapper d-none d-sm-flex" [class]="colorClass() + '-bg'">
				<fa-duotone-icon [icon]="icon()" [class]="colorClass()" size="lg" secondaryOpacity="0.5" />
			</div>
			<div class="flex-grow-1 min-w-0">
				@if (isLoading()) {
					<div class="placeholder-glow">
						<span class="placeholder col-8 placeholder-sm mb-1 d-block"></span>
						<span class="placeholder col-5 placeholder-lg"></span>
					</div>
				} @else {
					<div class="text-muted small text-uppercase fw-semibold letter-spacing text-truncate">{{ title() }}</div>
					<div class="fs-4 fs-md-3 fw-bold">{{ value() | number }}</div>
				}
			</div>
			@if (routerLink()) {
				<fa-duotone-icon icon="arrow-right" class="stat-chevron text-muted" secondaryOpacity="0.9" />
			}
		</div>
	</div>
</ng-template>
